import React from 'react';

import { InfoIcon } from 'assets/images/index';
import Tooltip from 'components/Tooltip/index';
import { Lender } from 'enums/ApplicationsVariables';
import { maskMonetaryValue } from 'utils/stringUtils';
import { LoanOfferIndicatorsText } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.constants';
import styles from 'pages/Dashboard/steps/AcceptOffer/AcceptOffer/LoanOfferCard/LoanOfferCard.module.scss';
import { LoanOfferItem } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.types';
import { OfferDto } from 'api/OffersApi';
import { getTooltipTextForApr } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.utils';

export const getLoanOfferItems = (loanOffer: OfferDto, lender: string) => {
  const isQuiloLender = lender === Lender.Quilo;

  const details: LoanOfferItem[] = [
    {
      title: LoanOfferIndicatorsText.CashToYou,
      tooltipText: null,
      value: maskMonetaryValue(loanOffer.loanAmount),
    },
    {
      title: LoanOfferIndicatorsText.GrossLoan,
      tooltipText: 'This is your net loan plus applicable fees.',
      value: maskMonetaryValue(loanOffer.grossLoan),
    },
    {
      title: LoanOfferIndicatorsText.FixedRate,
      tooltipText: null,
      value: <span className={isQuiloLender ? styles.fixRateValueAsterisk : ''}>{loanOffer.fixedRate}%</span>,
    },
    {
      title: LoanOfferIndicatorsText.APR,
      tooltipText: getTooltipTextForApr({
        isProsperLender: loanOffer.lender === Lender.Prosper,
        rate: loanOffer.fixedRate,
        oneTimeFeePercentage: loanOffer.oneTimeFeePercentage,
      }),
      value: `${loanOffer.apr}%`,
    },
    {
      title: LoanOfferIndicatorsText.TermYears,
      tooltipText: null,
      value: loanOffer.termYears,
    },
  ];

  return details;
};

interface LoanOfferCardProps {
  title: string;
  loanOffer: OfferDto;
  lender: string;
}

const LoanOfferCard = ({ title, loanOffer, lender }: LoanOfferCardProps) => {
  return (
    <div className={styles.loanOfferCard}>
      {title && <div className={styles.title}>{title}</div>}
      {getLoanOfferItems(loanOffer, lender).map((getLoanOfferItem) => (
        <div key={getLoanOfferItem.title} className={styles.loanInformationRow}>
          <div className={styles.titleWithTooltip}>
            <div>{getLoanOfferItem.title}</div>
            {getLoanOfferItem.tooltipText && (
              <Tooltip title={getLoanOfferItem.tooltipText}>
                <InfoIcon className={styles.iconInfo} />
              </Tooltip>
            )}
          </div>
          <div className={styles.optionsValue}>{getLoanOfferItem.value}</div>
        </div>
      ))}
      <div className={styles.monthlyPaymentContainer}>
        <div>{LoanOfferIndicatorsText.MonthlyPayment}</div>
        <div>{maskMonetaryValue(loanOffer.monthlyPayment)}</div>
      </div>
    </div>
  );
};

export default LoanOfferCard;
